import IconTurretBlue from './IconTurretBlue';

export default IconTurretBlue;